import './hotspot.css'
import {React, Component, useState, useEffect} from "react";

import infoicon from '../../../../icons/icons8-info-128.png'
import materialicon from '../../../../icons/icons8-m-67.png'
import animationicon from '../../../../icons/icons8-a-67.png'

/**
 * 
 * @param {*} props 
 * @returns Prints the Hotspot and Annotation.
 */
export default function Hotspot(props) {

    // There are 3 states for Annotation: 1. show-on-click, 2. normally-hidden and 3. pop-on-hover
    const [annotationState, setAnnotationState] = useState('none');

    const getDataPosition = (annot) => {
        return `${annot.position.x} ${annot.position.y} ${annot.position.z}`;
    };

    const getDataNormal = (annot) => {
        return `${annot.normal.x} ${annot.normal.y} ${annot.normal.z}`;
    };


    return(
        // Dynamic Hotspot example: https://codesandbox.io/s/lingering-tree-d41cr?file=/src/App.js
        <div 
            className           =   "hotspot" 
            key                 =   {props.hotspot.hotspotName}
            slot                =   {`hotspot-${props.idx}`} 
            style               =   {{backgroundColor: (props.bkColor==='display-icon')? 'transparent' : props.bkColor}} 
            data-position       =   {getDataPosition(props.hotspot)}
            data-normal         =   {getDataNormal(props.hotspot)}
        >
            <div className="annotation" style={{display: annotationState}}> <b>{`${props.hotspot.hotspotName}`}</b> <br/> {props.msg} </div>;
            {(props.bkColor==='display-icon')
            ?
                <img 
                    className='pulsating-icon-class' 
                    src={(props.iconType==='info') ? infoicon : (props.iconType==='animation') ? animationicon : materialicon} 
                    height='20px' 
                    alt='icon'
                    onMouseOver={() => {
                        setAnnotationState('block');
                    }}
                    onMouseOut={() => {
                        setAnnotationState('none');
                    }}
                />
            :
                <> </>
            }
        </div>
    );
}